<div (click)="onPlayerAreaClick($event)" class="relative h-full flex justify-center items-center">
  <div class="audio-player max-w-[210px] md:max-w-[600px] h-[190px] md:h-full max-h-[80%] md:max-h-[250px] flex flex-col justify-center gap-3 md:gap-0">
    <audio
      #audioElement
      [src]="audioUrl"
      (loadedmetadata)="onLoadedMetadata()"
      (timeupdate)="onTimeUpdate()"
      (ended)="onAudioEnded()"
      (pause)="onAudioPaused()"
    ></audio>

    <div class="waveform md:mb-5" [class.playing]="isPlaying" [class.ending]="waveformScale < 1">
      <svg class="wave-svg" viewBox="0 0 100 38.05" xmlns="http://www.w3.org/2000/svg" [style.transform]="'scaleY(' + waveformScale + ')'">
        <path class="line line-1" d="M0.91,15L0.78,15A1,1,0,0,0,0,16v6a1,1,0,1,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H0.91Z"/>
        <path class="line line-2" d="M5.91,9L5.78,9A1,1,0,0,0,5,10V28a1,1,0,1,0,2,0s0,0,0,0V10A1,1,0,0,0,6,9H5.91Z"/>
        <path class="line line-3" d="M10.91,0L10.78,0A1,1,0,0,0,10,1V37a1,1,0,1,0,2,0s0,0,0,0V1a1,1,0,0,0-1-1H10.91Z"/>
        <path class="line line-4" d="M15.91,10l-0.12,0A1,1,0,0,0,15,11V27a1,1,0,1,0,2,0s0,0,0,0V11a1,1,0,0,0-1-1H15.91Z"/>
        <path class="line line-5" d="M20.91,15l-0.12,0A1,1,0,0,0,20,16v6a1,1,0,0,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H20.91Z"/>
        <path class="line line-6" d="M25.91,10l-0.12,0A1,1,0,0,0,25,11V27a1,1,0,1,0,2,0s0,0,0,0V11a1,1,0,0,0-1-1H25.91Z"/>
        <path class="line line-7" d="M30.91,0L30.78,0A1,1,0,0,0,30,1V37a1,1,0,1,0,2,0s0,0,0,0V1a1,1,0,0,0-1-1H30.91Z"/>
        <path class="line line-8" d="M35.91,9L35.78,9A1,1,0,0,0,35,10V28a1,1,0,1,0,2,0s0,0,0,0V10a1,1,0,0,0-1-1H35.91Z"/>
        <path class="line line-9" d="M40.91,15l-0.12,0A1,1,0,0,0,40,16v6a1,1,0,1,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H40.91Z"/>
        <path class="line line-10" d="M45.91,10l-0.12,0A1,1,0,0,0,45,11V27a1,1,0,1,0,2,0s0,0,0,0V11a1,1,0,0,0-1-1H45.91Z"/>
        <path class="line line-11" d="M50.91,0L50.78,0A1,1,0,0,0,50,1V37a1,1,0,1,0,2,0s0,0,0,0V1a1,1,0,0,0-1-1H50.91Z"/>
        <path class="line line-12" d="M55.91,9L55.78,9A1,1,0,0,0,55,10V28a1,1,0,1,0,2,0s0,0,0,0V10a1,1,0,0,0-1-1H55.91Z"/>
        <path class="line line-13" d="M60.91,15l-0.12,0A1,1,0,0,0,60,16v6a1,1,0,1,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H60.91Z"/>
        <path class="line line-14" d="M65.91,9L65.78,9A1,1,0,0,0,65,10V28a1,1,0,1,0,2,0s0,0,0,0V10A1,1,0,0,0,66,9H65.91Z"/>
        <path class="line line-15" d="M70.91,0L70.78,0A1,1,0,0,0,70,1V37a1,1,0,1,0,2,0s0,0,0,0V1a1,1,0,0,0-1-1H70.91Z"/>
        <path class="line line-16" d="M75.91,10l-0.12,0A1,1,0,0,0,75,11V27a1,1,0,1,0,2,0s0,0,0,0V11a1,1,0,0,0-1-1H75.91Z"/>
        <path class="line line-17" d="M80.91,15l-0.12,0A1,1,0,0,0,80,16v6a1,1,0,0,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H80.91Z"/>
        <path class="line line-18" d="M85.91,10l-0.12,0A1,1,0,0,0,85,11V27a1,1,0,1,0,2,0s0,0,0,0V11a1,1,0,0,0-1-1H85.91Z"/>
        <path class="line line-19" d="M90.91,0L90.78,0A1,1,0,0,0,90,1V37a1,1,0,1,0,2,0s0,0,0,0V1a1,1,0,0,0-1-1H90.91Z"/>
        <path class="line line-20" d="M95.91,9L95.78,9A1,1,0,0,0,95,10V28a1,1,0,1,0,2,0s0,0,0,0V10a1,1,0,0,0-1-1H95.91Z"/>
      </svg>
    </div>

   <div class="custom-controls" >
     <!-- Barra de progreso -->
       <!-- <div (click)="seekAudio($event)" class="absolute md:static bottom-0 left-0 right-0 md:pt-[10px] md:px-1 md:pb-2 cursor-pointer">
         <div class="progress-bar">
           <div class="progress-filled" [style.width.%]="progress"></div>
         </div>
       </div> -->

       <ion-range aria-label="progress"
       [value]="currentTime"
       class="audio-progress-bar p-0 absolute md:static bottom-0 left-0 right-0"
       (ionInput)="onRangeInput($event)"
       (ionChange)="progressBarChange($event)"
       [min]="0"
       [max]="duration | number:'1.0-0'"
       ></ion-range>

     <div class="controls-panel flex justify-center md:justify-between items-center  text-white md:mt-2">
       <div class="controls-left flex items-center gap-[10px]">
         <!-- Play/Pause -->
           <button class="video-play-button absolute md:static top-1/2 left-1/2"
           (click)="togglePlayPause($event)"
           [ngClass]="{'force-hidden-sm': !showControls}"
           >
             <ion-icon *ngIf="!isPlaying" name="play" class="player-icon"></ion-icon>
             <mat-icon *ngIf="isPlaying" class="mdi mdi-pause player-icon" ></mat-icon>
           </button>
           <!-- Volumen -->
           <div class="volume-control absolute md:static left-0 bottom-4"
           (mouseenter)="showVolumeBar = true"
           (mouseleave)="showVolumeBar = false"
           >
             <button class="control-btn" (click)="toggleMute()" title="Silenciar">
               <ion-icon [name]="getVolumeIcon()" class="player-icon"></ion-icon>
             </button>
             <input
               type="range"
               class="volume-slider"
               [class.open]="showVolumeBar"
               min="0"
               max="1"
               step="0.01"
               [value]="volume"
               (input)="onVolumeChange($event)">
           </div>
           <!-- Tiempo -->
           <div class="text-base whitespace-nowrap -mb-4 md:mb-0 h-10 flex justify-center items-center px-4 rounded-xl bg-[#3a393996] hover:bg-[#ffffff33] pointer-events-none"
           >
             <span>{{ formatTime(currentTime) }} / {{ formatTime(duration) }}</span>
           </div>
       </div>

       <div class="controls-right flex items-center gap-[10px] h-[40px] absolute md:static top-2 right-2">
         <!-- speed control-->
         <div class="relative flex items-center">
           <button class="control-btn" (click)="toggleSpeedMenu()" title="Velocidad" >
             <mat-icon class="mdi mdi-speedometer player-icon"></mat-icon>
           </button>
           <div *ngIf="showSpeedMenu" class="speed-menu px-1" (mouseleave)="showSpeedMenu = false">
             <button *ngFor="let speed of speedOptions"
               class="block w-full p-1 border-none text-white cursor-pointer text-sm mb-[1px]"
               (click)="setPlaybackSpeed(speed)"
             >
               <span class="speed-option-item p-2 w-full rounded-lg flex justify-end items-center py-[4px] px-3"
               [class.active]="speed === playbackSpeed">
               {{ speed === 1 ? 'Normal' : speed +  'x' }}
               </span>
             </button>
           </div>
         </div>
       </div>
     </div>

   </div>
  </div>
</div>

